import { EmailTemplateTypes } from '../../common/constants'
import { InvoiceReminderTokens, PaymentLinkToken, ProposalLinkToken, Token, Tokens } from '../RichTextEditor/tokenModel'

export type EmailTemplate = {
  id: number
  guid: string
  name: string
  eventDescription?: string
  emailSubject?: string
  emailBody?: string
  type: number
}

export const defaultEmailTemplate = (): EmailTemplate => ({
  id: 0,
  guid: '',
  name: '',
  type: 0
})

export const emailTemplateTokens = (type: number): Token[] => {
  if (type === EmailTemplateTypes.Proposal) {
    return Tokens
  }
  if (type === EmailTemplateTypes.InvoiceReminder) {
    return InvoiceReminderTokens
  }
  return []
}

export const hasRichTextSubject = (type: number): boolean => {
  return emailTemplateTokens(type).length > 0
}

export const requiredBodyPlaceholder = (type: number): string | undefined => {
  if (type === EmailTemplateTypes.Proposal) {
    return ProposalLinkToken
  }
  if (type === EmailTemplateTypes.InvoiceReminder) {
    return PaymentLinkToken
  }
  return undefined
}

export const requiredBodyPlaceholderError = (type: number, body: string | undefined): string | undefined => {
  const placeholder = requiredBodyPlaceholder(type)
  if (placeholder === undefined) {
    return undefined
  }
  if ((body ?? '').includes(`{{${placeholder}}}`)) {
    return undefined
  }
  return `The email body must contain {{${placeholder}}} text at least once.`
}
